import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { JfseService, ReaderStatus } from 'src/app/services/jfse/jfse.service';
import { FseIo, FseException } from 'src/app/utils/interfaces/new/FseIo.interface';
import { RessourceService } from 'src/app/services/ressource/ressource.service';
import { LoginService } from 'src/app/services/login/login.service';
import { RessourceSetting } from 'src/app/utils/interfaces/new/RessourceSetting';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';
import { isAllowedIframeUrl } from 'src/app/utils/safe-url';

@Component({
  selector: 'app-office-jfse',
  templateUrl: './office-jfse.component.html',
  styleUrls: ['./office-jfse.component.scss']
})
export class OfficeJfseComponent implements OnInit {
  public   form: FormGroup;
  public idJfse: string = '';
  public idLecteur: string = '';
  public iframeUrl: SafeResourceUrl | null = null;
  public currentUser: any;
  private settingsUser: Array<RessourceSetting> = [];
  public token: string = '';

  constructor(
    private jfseService: JfseService,
    private _resourceSrv: RessourceService,
    private _login: LoginService,
    private fb: FormBuilder,
    private sanitizer: DomSanitizer,
    private snackbarService: SnackbarService,
) {}

  async ngOnInit(): Promise<void> {
    // Initialisation du formulaire
    this.form = this.fb.group({
        idJfse: [ 0, [Validators.required, Validators.pattern(/^[0-9]+$/)]],
        idLecteur: ['',[Validators.required]]
      });

    this.AdminToken();
  }

  public AdminToken(): void {
    // Récupérer le token administrateur
    const idJfse = 0; //admin=0

    this.jfseService.getAdminToken().then((token) => {
        console.log('Token récupéré :', token);
        this.token = token;
    }).catch((error) => {
        console.error('Erreur lors de la récupération du token :', error);
    });
  }

  async manageLOT(): Promise<void> {
    // Ne rien faire si le formulaire est invalide
    if (this.form.invalid) {
        this.snackbarService.openSnackBar('Veuillez remplir tous les champs obligatoires.');
    //   console.warn('Formulaire invalide');
      return;
    }

    const idLecteur: string = this.form.value.idLecteur;
    const idJfse: number = Number(this.form.value.idJfse);

    // Validation manuelle supplémentaire si besoin
    if (!idLecteur || idJfse <= 0 || isNaN(idJfse)) {
      this.snackbarService.openSnackBar('Veuillez vérifier les valeurs saisies.');
    //   console.warn('Valeurs invalides');
      return;
    }

    try {
      const retourGestFSE: FseIo = await this.jfseService.initTabGuiLOT(idJfse, idLecteur);
      if (retourGestFSE?.method.output?.url && isAllowedIframeUrl(retourGestFSE.method.output.url)) {
        this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(retourGestFSE.method.output.url);
      }
    } catch (err) {
        this.snackbarService.openSnackBar('Erreur lors de l\'appel gestion LOT et Fichier');
    //   console.error('Erreur lors de l\'appel gestion LOT et Fichier', err);
    }
  }

  async manageEtablissement(): Promise<void> {

    try {
      const idLecteur: string = this.form.value.idLecteur;
      const retourGestFSE: FseIo = await this.jfseService.initTabGestEtab(idLecteur,this.token);
      if (retourGestFSE?.method.output?.url && isAllowedIframeUrl(retourGestFSE.method.output.url)) {
        this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(retourGestFSE.method.output.url);
      }
    } catch (err) {
        this.snackbarService.openSnackBar('Erreur lors de l\'appel gestion établissement');
    //   console.error('Erreur lors de l\'appel gestion LOT et Fichier', err);
    }
  }

  async manageUtilisateur(): Promise<void> {

    const idLecteur: string = this.form.value.idLecteur;

    // Validation manuelle supplémentaire si besoin
    if (!idLecteur) {
      this.snackbarService.openSnackBar('Veuillez saisir un id Lecteur.');
    //   console.warn('Valeurs invalides');
      return;
    }

    try {
      const retourGestFSE: FseIo = await this.jfseService.initTabGestUser(idLecteur,this.token);
      if (retourGestFSE?.method.output?.url && isAllowedIframeUrl(retourGestFSE.method.output.url)) {
        this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(retourGestFSE.method.output.url);
      }
    } catch (err) {
        this.snackbarService.openSnackBar('Erreur lors de l\'appel gestion établissement');
    //   console.error('Erreur lors de l\'appel gestion LOT et Fichier', err);
    }
  }

  async manageParamAdmin(): Promise<void> {

    try {
      const retourGestFSE: FseIo = await this.jfseService.initParamAdmin(this.token);
      if (retourGestFSE?.method.output?.url && isAllowedIframeUrl(retourGestFSE.method.output.url)) {
        this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(retourGestFSE.method.output.url);
      }
    } catch (err) {
        this.snackbarService.openSnackBar('Erreur lors de l\'appel gestion établissement');
    //   console.error('Erreur lors de l\'appel gestion LOT et Fichier', err);
    }
  }

}
